import { AppThunk } from '../types';
import { getClientOverviewAction } from './clientOverviewSlice';

export const initClientOverview =
  (clientId: string): AppThunk =>
  async (dispatch, getState) => {
    dispatch(getClientOverviewAction(clientId));
  };
